import { collection, getDocs, setDoc, updateDoc, doc, deleteDoc, orderBy, query } from 'firebase/firestore';
import { db } from '../../firebase_config';
import { MERCHANT_V2_COLLECTION, MerchantV2 } from '../../type';

class MerchantV2Service {
  async getAll(): Promise<MerchantV2[]> {
    const q = query(collection(db, MERCHANT_V2_COLLECTION), orderBy('merchant_name', 'asc'));
    const snapshot = await getDocs(q);

    const merchants = snapshot.docs.map(doc => ({
      ...doc.data(),
    } as MerchantV2));
    return merchants;
  }

  async create(merchant: MerchantV2): Promise<void> {
    await setDoc(doc(db, MERCHANT_V2_COLLECTION, merchant.merchant_id), merchant);
  }

  async update(merchant_id: string, merchant: Partial<MerchantV2>): Promise<void> {
    const { merchant_id: _, ...merchantData } = merchant;
    await updateDoc(doc(db, MERCHANT_V2_COLLECTION, merchant_id), merchantData);
  }

  async delete(merchant_id: string): Promise<void> {
    await deleteDoc(doc(db, MERCHANT_V2_COLLECTION, merchant_id));
  }
}

export const merchantV2Service = new MerchantV2Service();
